import type { ContentNode, DocumentState } from '../document-types';
import type { NodeHandler, RenderContext } from './types';

export class CodeBlockHandler implements NodeHandler {
  readonly type = 'codeBlock';

  render(
    node: ContentNode | DocumentState,
    _parent: ContentNode | DocumentState | null,
    childContent: string,
    _ctx: RenderContext
  ): string {
    const language = (node as ContentNode).attrs?.['language'] ?? '';
    return '```' + language + '\n' + childContent + '```\n\n';
  }
}
